import { ErrorCode } from './error_code';
export class AppError extends ErrorCode {
    constructor(options) {
        super(options.message);
        this.name = options.name;
        this.code = options.code;
        this.desc = options.desc;
        this.status = options.status;
        this.external = options.external;
    }
    formattedMessage() {
        let message = this.message;
        if (typeof this.code === 'number') {
            message += `(this.code)`;
        }
        return message;
    }
    toString() {
        return `[name=${this.name}, message=${this.message}, status=${this.status}, desc=${this.desc}]`;
    }
    setExternalData(data) {
        this.external = data;
    }
    static timeoutError() {
        return new AppError({ name: AppError.NAME_TIMEOUT, message: 'This operation is timeout.' });
    }
    static fromError(error) {
        if (error instanceof AppError)
            return error;
        return new AppError({ name: AppError.NAME_UNKNOWN, message: AppError.MSG_ERR, desc: error.message });
    }
    static fromObject(obj) {
        return new AppError({ name: obj.name, message: obj.message, code: obj.code });
    }
    static unknownError(args) {
        return new AppError({ name: AppError.NAME_UNKNOWN, message: AppError.MSG_ERR, desc: args.desc });
    }
    static webrtcDisconnectedError() {
        return new AppError({ name: AppError.NAME_WEBRTC_DISCONNECTED, message: AppError.MSG_WEBRTC_DISCONNECTED });
    }
}
